interface HTMLElementTagNameMap {
	"a": HTMLAnchorElement;
	"abbr": HTMLElement;
	"address": HTMLElement;
	"area": HTMLAreaElement;
	"article": HTMLElement;
	"aside": HTMLElement;
	"audio": HTMLAudioElement;
	"b": HTMLElement;
	"base": HTMLBaseElement;
	"bdi": HTMLElement;
	"bdo": HTMLElement;
	"blockquote": HTMLQuoteElement;
	"body": HTMLBodyElement;
	"br": HTMLBRElement;
	"button": HTMLButtonElement;
	"canvas": HTMLCanvasElement;
	"caption": HTMLTableCaptionElement;
	"cite": HTMLElement;
	"code": HTMLElement;
	"col": HTMLTableColElement;
	"colgroup": HTMLTableColElement;
	"data": HTMLDataElement;
	"datalist": HTMLDataListElement;
	"dd": HTMLElement;
	"del": HTMLModElement;
	"details": HTMLDetailsElement;
	"dfn": HTMLElement;
	"dialog": HTMLDialogElement;
	"dir": HTMLDirectoryElement;
	"div": HTMLDivElement;
	"dl": HTMLDListElement;
	"dt": HTMLElement;
	"em": HTMLElement;
	"embed": HTMLEmbedElement;
	"fieldset": HTMLFieldSetElement;
	"figcaption": HTMLElement;
	"figure": HTMLElement;
	"font": HTMLFontElement;
	"footer": HTMLElement;
	"form": HTMLFormElement;
	"frame": HTMLFrameElement;
	"frameset": HTMLFrameSetElement;
	"h1": HTMLHeadingElement;
	"h2": HTMLHeadingElement;
	"h3": HTMLHeadingElement;
	"h4": HTMLHeadingElement;
	"h5": HTMLHeadingElement;
	"h6": HTMLHeadingElement;
	"head": HTMLHeadElement;
	"header": HTMLElement;
	"hgroup": HTMLElement;
	"hr": HTMLHRElement;
	"html": HTMLHtmlElement;
	"i": HTMLElement;
	"iframe": HTMLIFrameElement;
	"img": HTMLImageElement;
	"input": HTMLInputElement;
	"ins": HTMLModElement;
	"kbd": HTMLElement;
	"label": HTMLLabelElement;
	"legend": HTMLLegendElement;
	"li": HTMLLIElement;
	"link": HTMLLinkElement;
	"main": HTMLElement;
	"map": HTMLMapElement;
	"mark": HTMLElement;
	"marquee": HTMLMarqueeElement;
	"menu": HTMLMenuElement;
	"meta": HTMLMetaElement;
	"meter": HTMLMeterElement;
	"nav": HTMLElement;
	"noscript": HTMLElement;
	"object": HTMLObjectElement;
	"ol": HTMLOListElement;
	"optgroup": HTMLOptGroupElement;
	"option": HTMLOptionElement;
	"output": HTMLOutputElement;
	"p": HTMLParagraphElement;
	"param": HTMLParamElement;
	"picture": HTMLPictureElement;
	"pre": HTMLPreElement;
	"progress": HTMLProgressElement;
	"q": HTMLQuoteElement;
	"rp": HTMLElement;
	"rt": HTMLElement;
	"ruby": HTMLElement;
	"s": HTMLElement;
	"samp": HTMLElement;
	"script": HTMLScriptElement;
	"section": HTMLElement;
	"select": HTMLSelectElement;
	"slot": HTMLSlotElement;
	"small": HTMLElement;
	"source": HTMLSourceElement;
	"span": HTMLSpanElement;
	"strong": HTMLElement;
	"style": HTMLStyleElement;
	"sub": HTMLElement;
	"summary": HTMLElement;
	"sup": HTMLElement;
	"table": HTMLTableElement;
	"tbody": HTMLTableSectionElement;
	"td": HTMLElement;
	"template": HTMLTemplateElement;
	"textarea": HTMLTextAreaElement;
	"tfoot": HTMLTableSectionElement;
	"th": HTMLElement;
	"thead": HTMLTableSectionElement;
	"time": HTMLTimeElement;
	"title": HTMLTitleElement;
	"tr": HTMLTableRowElement;
	"track": HTMLTrackElement;
	"u": HTMLElement;
	"ul": HTMLUListElement;
	"var": HTMLElement;
	"video": HTMLVideoElement;
	"wbr": HTMLElement;
}

export function fragment(doc: Document = document): DocumentFragment {
	return doc.createDocumentFragment();
}

export function text(txt: string, doc: Document = document): Text {
	return doc.createTextNode(txt);
}

export function node<K extends keyof HTMLElementTagNameMap>(tagName: K, options: Partial<HTMLElementTagNameMap[K]> = {}, content = "", doc: Document = document): HTMLElementTagNameMap[K] {
	const { style, ...rest } = options;

	// TODO: toto je jen pro nalezeni chyby, pak ten try catch zase dame pryc
	try {
		const element = doc.createElement(tagName);

		if (style) {
			element.setAttribute("style", style.toString());
		}

		Object.assign(element, rest);

		if (content) {
			element.appendChild(text(content, doc));
		}

		return element as HTMLElementTagNameMap[K];
	} catch (ex) {
		//
	}

	return doc.createElement("div") as HTMLElementTagNameMap[K];
}

const ICONS = {
	/* eslint-disable */
	"elevation": "<svg viewBox=\"0 0 24 24\">\n    <path d=\"M10.3636364,12.5454545 L13,16 L11.5454545,17.0909091 C10,15.0909091 7.45454545,11.6363636 7.45454545,11.6363636 L2,18.9090909 L22,18.9090909 L13.8181818,8 L10.3636364,12.5454545 Z\" id=\"path-1\"></path>\n</svg>\n",
};

/**
 * Vytvoří ikonu
 */
export function icon(type = "", title = "", doc: Document = document) {
	const str = ICONS[type];

	if (!str) {
		// eslint-disable-next-line no-console
		console.error("Bad icon type '%s'", type);

		const span = node("span", {}, "🔥", doc);

		span.style.fontSize = "24px";

		return span;
	}

	const tmp = node("div", { innerHTML: str }, undefined, doc);
	const svg = tmp.querySelector("svg");

	svg.classList.add("icon");
	svg.classList.add(`icon-${type}`);

	if (title) {
		const titleElement = doc.createElementNS("http://www.w3.org/2000/svg", "title");

		titleElement.appendChild(text(title, doc));
		svg.appendChild(titleElement);
	}

	return svg;
}

export function isMapycz() {
	return "Mapy" in window;
}
